angular.module('unergie.main')
.filter('metaInvoiceType', () => {
    return function (value) {
        switch (value) {
            case 'INVOICE':
                return 'Facture'
            case 'REVERSAL':
                return 'Extourne'
            case 'PENALTY':
                return 'Pénalité'
            case 'COMPENSATION':
                return 'Rétribution'
            default:
                return value
        }
    }
})
